import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=f355737e"
import script from "./EditMessage.vue?vue&type=script&lang=ts"
export * from "./EditMessage.vue?vue&type=script&lang=ts"
import style0 from "../../scss/base.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports